import { Link } from "react-router-dom";
import { Box } from "@mui/material";

import { DotIcon, ShipdIcon } from "components/icons";

type TitleProps = {
    collapsed: boolean;
};

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
    return (
        <Link to="/">
            <Box
                sx={{
                    height: "72px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "text.primary",
                }}
            >
                {collapsed ? <DotIcon /> : <ShipdIcon />}
            </Box>
        </Link>
    );
};
